import { Sparkles } from "lucide-react";
import { SpecialtyPage } from "@/components/SpecialtyPage";

export default function AestheticMedicine() {
  return (
    <SpecialtyPage
      icon={Sparkles}
      titleKey="specialties.aesthetic.title"
      subtitleKey="specialties.aesthetic.subtitle"
      overviewKey="specialties.aesthetic.overview"
      procedures={[
        {
          nameKey: "specialties.aesthetic.procedure1Name",
          descriptionKey: "specialties.aesthetic.procedure1Desc",
          durationKey: "specialties.aesthetic.procedure1Duration",
          recoveryKey: "specialties.aesthetic.procedure1Recovery",
        },
        {
          nameKey: "specialties.aesthetic.procedure2Name",
          descriptionKey: "specialties.aesthetic.procedure2Desc",
          durationKey: "specialties.aesthetic.procedure2Duration",
          recoveryKey: "specialties.aesthetic.procedure2Recovery",
        },
        {
          nameKey: "specialties.aesthetic.procedure3Name",
          descriptionKey: "specialties.aesthetic.procedure3Desc",
          durationKey: "specialties.aesthetic.procedure3Duration",
          recoveryKey: "specialties.aesthetic.procedure3Recovery",
        },
      ]}
      advantagesKeys={[
        "specialties.aesthetic.advantage1",
        "specialties.aesthetic.advantage2",
        "specialties.aesthetic.advantage3",
      ]}
      faq={[
        { questionKey: "specialties.aesthetic.faq1Q", answerKey: "specialties.aesthetic.faq1A" },
        { questionKey: "specialties.aesthetic.faq2Q", answerKey: "specialties.aesthetic.faq2A" },
        { questionKey: "specialties.aesthetic.faq3Q", answerKey: "specialties.aesthetic.faq3A" },
        { questionKey: "specialties.aesthetic.faq4Q", answerKey: "specialties.aesthetic.faq4A" },
        { questionKey: "specialties.aesthetic.faq5Q", answerKey: "specialties.aesthetic.faq5A" },
      ]}
      priceFromKey="specialties.aesthetic.priceFrom"
      priceNoteKey="specialties.aesthetic.priceNote"
      comparisonKey="specialties.aesthetic.comparison"
      ctaTitleKey="specialties.aesthetic.ctaTitle"
    />
  );
}
